fx.ns("desktop.common.behaviour", class InnerDragger extends shared.Behaviour{

    constructor(mouse, model)
    {    
        super(mouse, "drag", model);  

        this.model = model;

        this._currentModel;
        
        this.maxSide = 120;

        this.on("updated", this._onUpdated, this.model);
    }

    get currentModel()
    {
        return this._currentModel;
    }

    set currentModel(val)
    {
        if (this._currentModel != val)
            this._currentModel = val;
    }

    get draggData()
    {
        if (!this._draggData)
            this._draggData = {};

        return this._draggData;
    }

    set draggData(val)
    {
        this._draggData = val;
    }

    // If we are dragging a picture, and it's begin uploaded, once it's uploaded, it's ID is updated, so we have to update dragging image content propoerty
    _onUpdated(e)
    {
        if (!this._draggData)
            return;

        if ( e.action.type == "update" && e.action.model instanceof models.Photo )
        {
            if (e.action.previous.id == this.draggData.content)
                this.draggData.content = e.action.data.id;
        }
    }

    start(event)
    {
        super.start();

        this.element = event.element;

        if (!this.element.SVGElement) return;

        this.currentModel = event.area.data;

        this.element.addClass("dragging");
     
        this.startY = event.originalEvent.pageY;
        this.startX = event.originalEvent.pageX;
        this.radians = (Math.PI / 180) * this.element.rotation;

        this.dragIcon = fx.dom.parent(event.originalEvent.target, ".drag");

        fx.dom.css(this.dragIcon, {display : "none"} );

        this.draggedSVG = this.element.SVGElement.clone();
        this.draggedSVG.node.style.outline = null;
        this.draggedSVG.node.style.opacity = null;
        this.draggedImageContainer = this.draggedSVG.select(".container");
        this.draggedSVG.unclip();
        this.draggedSVG.unfilter();
        this.draggedSVG.unmask();
        this.draggedSVG.opacity(0.8);
        
        this.draggedSVG.animate(100, "sineIn").opacity(0.8);
     
        this.xInner = this.element.xInner;   
        this.yInner = this.element.yInner;
    }

    action(event)
    {
        super.action();

        if (!this.draggedSVG)
            return;

        let eventX = event.originalEvent.pageX;
        let eventY = event.originalEvent.pageY;

        let elts = fx.graphics.elementsFromPoint(eventX, eventY, 2);

        if (elts.includes(this.element.node)) //movement inside the picture
        {
            if (this.draggData.draggElement)
            {
                this.cleanComponents();
                this.removeDraggElement();
            }

            this.draggedSVG.opacity(0.8);

            let xMove = ( eventX - this.startX ) / this.element.parentScale  / this.model.zoom.realValue;
            let yMove = ( eventY - this.startY) / this.element.parentScale  / this.model.zoom.realValue;

            let currentXInner = this.xInner + Math.cos(this.radians) * xMove + Math.sin(this.radians) * yMove;
            let currentYInner = this.yInner - Math.sin(this.radians) * xMove + Math.cos(this.radians) * yMove;

            if (this.element.rotationInner == 0)
            {
                if (currentXInner > 0)
                    currentXInner = 0;

                if (currentXInner < ( this.element.width - this.element.widthInner) )
                    currentXInner = this.element.width - this.element.widthInner;

                if (currentYInner > 0)
                    currentYInner = 0;

                if (currentYInner < ( this.element.height - this.element.heightInner) )
                    currentYInner = this.element.height - this.element.heightInner;
            }
            else
            if (this.element.rotationInner == 90)
            {
                if (currentXInner > 0)
                    currentXInner = 0;

                if (currentYInner > 0)
                    currentYInner = 0;

                if (currentXInner < -(this.element.heightInner - this.element.width))
                    currentXInner = -(this.element.heightInner - this.element.width);
                
                if (currentYInner < - (this.element.widthInner - this.element.height) )
                    currentYInner = - (this.element.widthInner - this.element.height);
            }
            else
            if (this.element.rotationInner == 180)
            {
                if (currentXInner > 0)
                    currentXInner = 0;

                if (currentYInner > 0)
                    currentYInner = 0;

                if (currentXInner < -(this.element.widthInner -this.element.width))
                    currentXInner = -(this.element.widthInner -this.element.width);

                if (currentYInner < -(this.element.heightInner -this.element.height))
                    currentYInner = -(this.element.heightInner -this.element.height);

            }
            else
            if (this.element.rotationInner == 270)
            {
                if (currentXInner > 0)
                    currentXInner = 0;

                if (currentYInner > 0)
                    currentYInner = 0;

                if (currentXInner < -(this.element.heightInner -this.element.width))
                    currentXInner = -(this.element.heightInner -this.element.width);

                if (currentYInner < -(this.element.widthInner -this.element.height))
                    currentYInner = -(this.element.widthInner -this.element.height);
            }

            this.currentXInner = currentXInner;
            this.currentYInner = currentYInner;

            this.element.moveInner(this.currentXInner , this.currentYInner);
            
            this.draggedImageContainer.attr("transform", "translate(" + this.currentXInner + "," + this.currentYInner + ")");
        }
        else
        // movement outside the picture. Invert two pictures
        {
            if (!this.element || !this.element.data) return;

            this.draggedSVG.opacity(0);

            if ( this.draggData.draggElement)
            {
                let elements = [];
            
                // finding photos excluding dragged 
                for (let i = 0; i < elts.length; i++)
                {
                    if (fx.dom.parent(elts[i], ".backcover"))
                    {
                        elements = [];
                        break;
                    }

                    let element = fx.dom.parent(elts[i], "." + this.draggData.class);

                    if (element && element.getAttribute("data-id") != this.element.data.id)
                    {
                        if (element && !elements.includes(element))
                            elements.push(element);
                    }
                }

                if (elements.length == 0)
                    this.cleanComponents();

                else
                {
                    let component = elements[0];
                    if(!component) return;

                    let componentDataId = component.getAttribute("data-id");
                    
                    let currentArea = fx.dom.parent(component, ".Area");
                    if (!currentArea)
                        return;

                    let currentAreaId = currentArea.getAttribute("data-id");
                    this.currentModel = this.model.creation.elements.find( elem => elem.id == currentAreaId);

                    let pageComponent = this.currentModel.getComponent( componentDataId );

                    if (this.draggData.overPageComponent && pageComponent != this.draggData.overPageComponent)
                        this.cleanComponents();

                    this.draggData.overPageComponent = pageComponent;
                    this.draggData.overComponent = component;
                    this.draggData.dropAllowed = component.getAttribute("data-drop-allowed");

                    if (pageComponent && this.draggData.dropAllowed && !this.draggData.dragOver) 
                    {
                        pageComponent.event("drag-over", {overcontent : this.draggData.content});
                        // invert current element
                        this.element.data.event("drag-over", {overcontent : pageComponent.content});
                        this.draggData.dragOver = true;
                    }
                }

                if (this.draggData.offset)  // fix trackjs crash
                {
                    let xPos = eventX - (this.draggData.offset.width * this.draggData.offset.ratio) / 2;
                    let yPos = eventY - (this.draggData.offset.height * this.draggData.offset.ratio) / 2;

                    fx.dom.css(this.draggData.draggElement, {left : xPos, top : yPos});
                }
            }
            else
            {
                // create draggable element
                let element = fx.dom.parent(this.element, ".dragging");
                
                if (!element) return;
                
                this.draggData.draggElement = element.cloneNode(true);
                this.draggData.draggElement.id = Utils.newID();
                this.draggData.content = this.element.data.content;
                this.draggData.class = this.element.className;
                this.draggData.dragOver = false;
                this.draggData.overComponent = null;

                let draggImageContainer = fx.dom.find(".container", this.draggData.draggElement)[1];
                
                if (!draggImageContainer) return; // fix trackjs crash

                fx.dom.css(draggImageContainer, {transform: "translate(0, 0)"});
                fx.dom.css(draggImageContainer.parentNode, {opacity: 1});
                
                let width = draggImageContainer.getAttribute("width");
                let height = draggImageContainer.getAttribute("height");

                let ratio;

                if ( (width/height) > 1)
                    ratio = this.maxSide / width;
                else
                    ratio = this.maxSide / height;

                this.draggData.offset = {   
                    width : width, 
                    height : height,
                    ratio: ratio
                };
                
                let xPos = event.originalEvent.pageX - (width * ratio) / 2;
                let yPos = event.originalEvent.pageY - (height * ratio) / 2;

                fx.dom.css(this.draggData.draggElement, {position: "absolute",  
                                                            cursor: "grabbing", 
                                                            opacity: 0.9, 
                                                            zIndex: 10, 
                                                            // transform:"translate3d(0px, 0px, 0px)",
                                                            transform: "scale(" + ratio + ")",
                                                            left : xPos, 
                                                            top : yPos, 
                                                            width: width , 
                                                            height: height });

                document.body.appendChild( this.draggData.draggElement );
            }
        }
    }

    cleanComponents()
    {
        if (this.draggData.overPageComponent)
        {
            this.draggData.overPageComponent.event("drag-out"); 
            this.element.data.event("drag-out"); 
            this.draggData.overPageComponent = null;
        }

        this.draggData.overComponent = null;
        this.draggData.dropAllowed = false;
        this.draggData.dragOver = false;
    }

    removeDraggElement()
    {
        if (this.draggData.draggElement && this.draggData.draggElement.parentNode)
            this.draggData.draggElement.parentNode.removeChild( this.draggData.draggElement );

        this.draggData = {};
    }

    end(event)
    {
        super.end();

        if (this.draggData.draggElement)
        {
            if (this.draggData.overPageComponent && this.draggData.overComponent.getAttribute("data-drop-allowed"))
            {
                this.draggData.overPageComponent.event("drag-out");

                if (this.element.data)  // fix trackjs crash
                    this.element.data.event("drag-out");

                let draggContent = {content : this.draggData.content};
                let dropContent = {content : this.draggData.overPageComponent.content};
                
                this.draggData.overPageComponent.update("drop", draggContent); 

                if (this.element.data)  // fix trackjs crash
                    this.element.data.update("drop", dropContent);
            }

            this.removeDraggElement();
        }

        if (this.draggedSVG)
            this.draggedSVG.remove();

        if (this.element)
            this.element.moveInnerEnd();

        this.element.removeClass("dragging");

        if (this.dragIcon)
            fx.dom.css(this.dragIcon, {display : "block"} );
        
        this.moveData = null;
        this.dragIcon = null;        
        this.draggedSVG = null;
        
        this.xInner = null;
        this.yInner = null;
        this.currentXInner = null;
        this.currentYInner = null;

        this.element = null;
        this.currentModel = null;
     
        this.startY = null;
        this.startX = null;
    }


});